<template>
  <router-link v-if="routerName" :to="{name: routerName, query: query}" class="btn-main" :class="[variant, size, disabled]"
               @click.native="clickHandler"
               @input.native="sendInputEvent($event)"
               @focus.native="sendFocusEvent($event)"
               @blur.native="sendBlurEvent($event)"
               @mousedown.native="sendMousedownEvent($event)"
               @mouseover.native="sendMouseoverEvent($event)"
               @mouseout.native="sendMouseoutEvent($event)"
               @keydown.native="sendKeydownEvent($event)"
               @keyup.native="sendKeyupEvent($event)"
               :disable="disabled" :target="target">
    <slot></slot>
  </router-link>
  <a v-else-if="href" :href="href" class="btn-main" :class="[variant, size, disabled]"
                      @click="clickHandler"
                      @input="sendInputEvent($event)"
                      @focus="sendFocusEvent($event)"
                      @blur="sendBlurEvent($event)"
                      @mousedown="sendMousedownEvent($event)"
                      @mouseover="sendMouseoverEvent($event)"
                      @mouseout="sendMouseoutEvent($event)"
                      @keydown="sendKeydownEvent($event)"
                      @keyup="sendKeyupEvent($event)"
                      :disable="disabled" :target="target">
    <slot></slot>
  </a>
  <button v-else class="text btn-main" :class="[variant, size, disabled]"
          @click="clickHandler"
          @input="sendInputEvent($event)"
          @focus="sendFocusEvent($event)"
          @blur="sendBlurEvent($event)"
          @mousedown="sendMousedownEvent($event)"
          @mouseover="sendMouseoverEvent($event)"
          @mouseout="sendMouseoutEvent($event)"
          @keydown="sendKeydownEvent($event)"
          @keyup="sendKeyupEvent($event)"
          :disable="disabled">
    <slot></slot>
  </button>
</template>

<script>
import FormEvent from '../../components/mixin/FormEvent'

export default {
  name: 'btn-main',
  mixins: [FormEvent],
  props: {
    variant: String,
    size: String,
    target: String,
    routerName: String,
    query: Object,
    href: String,
    trackingName: String,
    disabled: {
      type: String,
      default: null
    }
  },
  methods: {
    clickHandler: function (e) {
      this.sendClickEvent(e)
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.btn-main {
  display: inline-block;
  width: 380px;
  max-width: 100%;
  text-align: center;
  padding: 17px 40px;
  border-radius: 27px;
  font-size: 14px;
  line-height: 14px;
  background-position: right 32px center;
  background-repeat: no-repeat;
  @include mq-up(md) {
    border-radius: 30px;
    font-size: 20px;
    line-height: 24px;
  }
  &.-main {
    background-image: url('../../assets/images/icons/arrow-right-white.svg');
    background-size: 8px auto;
    background-color: $primary;
    color: $white;
    border: 1px solid $primary;
    &:hover {
      background-color: rgba($primary,0.8);
      border: 1px solid rgba($primary,0);
    }
  }
  &.-main-out {
    background-image: url('../../assets/images/icons/out-white.svg');
    background-size: 12px 12px;
    background-color: $primary;
    color: $white;
    border: 1px solid $primary;
    &:hover {
      background-color: rgba($primary,0.8);
      border: 1px solid rgba($primary,0);
    }
  }
  &.-normal {
    background-image: url('../../assets/images/icons/arrow-right-orange.svg');
    background-size: 8px auto;
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url('../../assets/images/icons/arrow-right-orange.svg');
      border: 1px solid $primary;
    }
  }
  &.-out {
    background-image: url('../../assets/images/icons/out.svg');
    background-size: 12px 12px;
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url('../../assets/images/icons/out.svg');
      border: 1px solid $primary;
    }
  }
  &.-plus {
    background-image: url('../../assets/images/icons/plus.svg');
    background-size: 12px auto;
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url('../../assets/images/icons/plus.svg');
      border: 1px solid $primary;
    }
  }
  &.-minus {
    background-image: url('../../assets/images/icons/minus.svg');
    background-size: 12px auto;
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
    &:hover {
      background-image: url('../../assets/images/icons/minus.svg');
      border: 1px solid $primary;
    }
  }
  &.-md {
    width: 440px;
    max-width: 100%;
  }
  &.-lg {
    width: 510px;
    max-width: 100%;
  }
  &.disabled {
    pointer-events: none;
    opacity: .3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BtnMain.vue